import {
  BCRYPT_SALT_ROUNDS,
  FRONTEND_BASE_URL,
  ServerConfigModule,
} from '@ip6m/server/config';
import {
  ClassSerializerInterceptor,
  Inject,
  Module,
  OnModuleInit,
  ValidationPipe,
} from '@nestjs/common';
import { ServerDataAccessUserModule } from '@ip6m/server/data-access-user';
import { ServerDataAccessOtpModule } from '@ip6m/server/data-access-otp';
import { ServerFeatureNotificationModule } from '@ip6m/server/feature-notification';
import { LoginAndRegistrationController } from './controllers/login-and-registration.controller';
import { OtpController } from './controllers/otp.controller';
import { OtpEntitySubscriber } from './subscribers/otp-entity.subscriber';
import { APP_INTERCEPTOR, APP_PIPE } from '@nestjs/core';
import { LoginAndRegistrationService } from './services/login-and-registration.service';
import { OtpService } from './services/otp.service';
import { ServerAuthModule } from '@ip6m/server/auth';
import * as Joi from 'joi';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';

@Module({
  imports: [
    ServerConfigModule,
    ServerFeatureConfigurationModule,
    ServerDataAccessUserModule,
    ServerDataAccessOtpModule,
    ServerAuthModule,
    ServerFeatureNotificationModule,
  ],
  controllers: [LoginAndRegistrationController, OtpController],
  providers: [
    LoginAndRegistrationService,
    { provide: APP_INTERCEPTOR, useClass: ClassSerializerInterceptor },
    {
      provide: APP_PIPE,
      useValue: new ValidationPipe(),
    },
    OtpService,
    OtpEntitySubscriber,
  ],
  exports: [],
})
export class ServerFeatureLoginAndRegistrationModule implements OnModuleInit {
  constructor(
    @Inject(BCRYPT_SALT_ROUNDS) private bcryptSaltRounds: string,
    @Inject(FRONTEND_BASE_URL) private frontendBaseUrl: string
  ) {}

  onModuleInit(): any {
    const schema = Joi.object({
      bcryptSaltRounds: Joi.number().min(5),
      frontendBaseUrl: Joi.string().uri(),
    });
    Joi.assert(this, schema);
  }
}
